// eslint-disable-next-line import/prefer-default-export
export function validProgress(progress) {
  if (!progress || progress < 0) {
    return 0;
  }

  if (progress > 100) {
    return 100;
  }

  return progress;
}
//# sourceMappingURL=utils.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/progress/utils.js
// module id = 332
// module chunks = 0